import type { DynamicProperty } from '../types';
import { evaluateDynamicValue } from '../utils/evaluateDynamicValue';

export function evaluateDynamicValues<Type, K = string>(
  source: DynamicProperty<Type>,
): Record<string, K> {
  const output: Record<string, K> = {};
  if (source) {
    Object.entries(source).forEach(([sourceKey, value]) => {
      output[sourceKey] = evaluateDynamicValue<K>(value);
    });
  }
  return output;
}
